export default __webpack_public_path__ + "static/media/utility-staking-incentives.d18e5e20.png";